import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md).
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.overlayLight,
    },
    safeareaContainer: {
      maxWidth: 481,
      backgroundColor: colors.surfaceElevated,
      borderRadius: 16,
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.25,
      shadowRadius: 4,
      elevation: 5,
    },
    bottomContainer: {
      padding: 32,
    },
    title: {
      fontFamily: FONTS.boldFont,
      fontSize: 24,
      color: colors.textPrimary,
    },
    subtitle: {
      fontFamily: FONTS.regularFont,
      fontSize: 16,
      color: colors.textMuted,
      marginTop: 16,
    },
    buttonsContainer: {
      flexDirection: 'row',
      marginTop: 32,
    },
    button: {
      flex: 1,
    },
    rippleContainer: {
      alignSelf: 'center',
      marginTop: 24,
    },
  });

export default makeStyles;
